import PropTypes from 'prop-types';
import React from 'react';

import ConversationIcon from 'components/lib/conversation_icon';
import ProfileAvatar from 'components/lib/profile_avatar';

export default function ItemIcon({ avatar, className, itemType, itemSubType, name, showIcon }) {
  let icon = null;
  if (showIcon) {
    icon =
      name || avatar ? (
        <ProfileAvatar profile={{ image: avatar, name }} convoBackground />
      ) : (
        <ConversationIcon
          iconClassName="conversationItem-avatarReplacementIcon"
          type={itemType}
          subType={itemSubType}
          convoBackground
        />
      );
  }
  return <div className={className}>{icon}</div>;
}

ItemIcon.defaultProps = {
  showIcon: true,
};

ItemIcon.propTypes = {
  avatar: PropTypes.string,
  className: PropTypes.string,
  itemType: PropTypes.string.isRequired,
  itemSubType: PropTypes.string,
  name: PropTypes.string,
  showIcon: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/scripts/presentation/components/customer/conversation_history/conversation_items_v2/icon/item_icon.jsx